import { toast } from 'react-toastify';
import axiosAPI from '../../utils/client/axiosAPI';
import { StorageStandResponse, StorageStandStorePayload } from './contracts';

export class StorageStand {
  public readonly id: number;
  public readonly name: string;
  public readonly storageRoomId: number;
  public readonly storageRoom?: any;
  public readonly productsCount: number;

  constructor({
    id,
    name,
    storage_room_id,
    storage_room,
    products_count = 0
  }: StorageStandResponse) {
    this.id = id;
    this.name = name;
    this.storageRoomId = storage_room_id;
    this.storageRoom = storage_room;
    this.productsCount = products_count ?? 0;
  }

  static async all(): Promise<StorageStand[]> {
    const { data } = await axiosAPI.get<StorageStandResponse[]>(
      '/storage-room-stands'
    );
    return data.map((stand) => new StorageStand(stand));
  }

  static async get(id: number): Promise<StorageStand> {
    const { data } = await axiosAPI.get(`/storage-room-stands/${id}`);
    return new StorageStand(data);
  }

  static async store(payload: StorageStandStorePayload): Promise<StorageStand> {
    const { data } = await axiosAPI.post('/admin/storage-room-stands', payload);
    return new StorageStand(data);
  }

  async update(payload: StorageStandStorePayload): Promise<StorageStand> {
    const { data } = await axiosAPI.put(
      `/admin/storage-room-stands/${this.id}`,
      payload
    );
    return new StorageStand(data);
  }

  async delete() {
    await axiosAPI.delete(`/admin/storage-room-stands/${this.id}`);
  }

  /**
   * Corrected download method using the authenticated axiosAPI client.
   */
  static async downloadPdf(standId: number, standName: string) {
    try {
      // 1. Use axiosAPI which handles authentication automatically.
      const response = await axiosAPI.get(`/storage-room-stands/${standId}/products-pdf`, {
        responseType: 'blob', // 2. Tell Axios to expect a binary file blob.
      });

      // For Axios, the blob data is in the `data` property.
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Polica-${standName}-proizvodi.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('PDF je uspešno preuzet!');
    } catch (err) {
      console.error("Failed to download PDF:", err); // Log the error for debugging.
      toast.error('Greška pri preuzimanju PDF-a');
    }
  }
}
